unit UColumnList;

interface

uses
  System.Contnrs, UColumnModel;

type
  TColumnList = class(TObjectList)
  private
    function GetItem(i: Integer): TColumnModel;
    procedure SetItem(i: Integer; item: TColumnModel);
    procedure Sort;
  public
    procedure Add(item: TColumnModel);
    procedure FromJson(json: string);
    property Items[i: Integer]: TColumnModel read GetItem write SetItem;
  end;

implementation

uses
  Js, system.SysUtils;

{ TColumnList }

procedure TColumnList.Add(item: TColumnModel);
begin
  inherited Add(item);
end;

procedure TColumnList.FromJson(json: string);
var obj: TJsObject;
    count, i: Integer;
begin
  Self.Clear;
  obj:=TJsJson.parseObject(json);
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to Count-1 do
      Self.Add(TColumnModel.Create(string(obj['Item'+IntToStr(i)])));
  end;
  Self.Sort;
end;

function TColumnList.GetItem(i: Integer): TColumnModel;
begin
  Result:=inherited GetItem(i) as TColumnModel;
end;

procedure TColumnList.SetItem(i: Integer; item: TColumnModel);
begin
  inherited SetItem(i,item);
end;

procedure TColumnList.Sort;
var i, j: Integer;
  procedure ChangeValue(i: Integer);
  var column: TColumnModel;
  begin
    column:=TColumnModel.Create;
    column.CopyFrom(Self.Items[i]);
    Self.Items[i].CopyFrom(Self.Items[i+1]);
    Self.Items[i+1].CopyFrom(column);
  end;
begin
  if Self.Count>1 then begin
    for j:=0 to Self.Count-2 do begin
      i:=Self.Count-2;
      while i>=j do begin
        if Self.Items[i].CompareTo(Self.Items[i+1])>0 then
          ChangeValue(i);
        Dec(i);
      end;
    end;
  end;
end;

end.
